import { configuration } from '../configuration';

export interface TenantResolveResponse {
  domain: string;
}

const FETCH_TIMEOUT_MS = 2000;

export default class TenantRegistryService {
  async resolveTenant(tenant: string, locale: string): Promise<TenantResolveResponse> {
    const url = `${configuration.urls.TENANT_REGISTRY_URL}resolve?tenant=${encodeURIComponent(tenant)}&locale=${encodeURIComponent(locale)}`;
    const response = await fetch(url, { signal: AbortSignal.timeout(FETCH_TIMEOUT_MS) });

    if (!response.ok) {
      throw new Error(`TenantRegistryService: failed to fetch domain for ${tenant}/${locale}: ${response.status}`);
    }

    return response.json();
  }
}
